<template>
    <span>
        <a href="#" @click="showme">{{username}}</a>

        <el-dialog v-if="isshowme" :visible.sync="isshowme" top="0px" class="mydialog2 modulewrap" append-to-body>
            <div class="mempopwrap" @click="shownavmain=false">
                <div class="mempopnav">
                    <div class="navline"></div>
                    <template v-if="!$store.getters.issmall">

                        <dl v-if="$common.basic.isarrayexist(memnav)">
                            <dd v-for="item in this.memnav" :key="item.id"><a href="#" :class="{cs:curnav==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                        </dl>
                    </template>
                    <template v-else>
                        <div class="memnavbox">
                            <a href="#" @click.stop.prevent="shownavmain=!shownavmain">{{$common.langinfo(c_navmain.title,c_navmain.title_en)}}</a>
                            <transition name="slidedown">
                                <div class="memmainnavmore" v-show="shownavmain">
                                    <dl v-if="$common.basic.isarrayexist(memnav)">
                                        <dd v-for="item in this.memnav" :key="item.id"><a href="#" :class="{cs:curnav==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                                    </dl>
                                </div>
                            </transition>

                        </div>

                    </template>
                </div>

                <div class="mempopbodywrap">
                    <div class="memsearch" v-if="curnav>0">
                        <div class="left">
                            <el-cascader ref="caslevel" v-model="caslevelvalue" v-if="$common.basic.isarrayexist(c_levellist)" :options="c_levellist" size="mini" class="memselect" popper-class="calevel"
                                         :props="casoption" :show-all-levels="false"
                                         :clearable="c_options.anycourse" :placeholder="$common.dicword('allcourse')" @change="optionchange"></el-cascader>
                        </div>
                        <div class="right"></div>
                    </div>

                    <div class="mempopbody">
                        <myScroll class="scroll">
                            <div v-if="curnav==0" class="profile">
                                <div class="face">
                                    <div class="faceimg"><img :src="$common.getface(me.face)" /></div>
                                </div>
                                <div class="info">
                                    <div class="view">
                                        <dl><dt>{{$common.dicword('username',true)}}</dt><dd>{{me.username}}</dd></dl>
                                        <dl><dt>{{$common.dicword('mobile',true)}}</dt><dd>{{me.mobile}}</dd></dl>
                                        <dl v-if="me.companyid>0"><dt>{{$common.dicword('school',true)}}</dt><dd>{{$common.langinfo(infoschool.title,infoschool.title_en)}}</dd></dl>
                                        <dl v-if="me.groupid>0"><dt>{{$common.dicword('infoclass',true)}}</dt><dd>{{$common.langinfo(infogroup.title,infogroup.title_en)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('realname',true)}}</dt><dd>{{me.realname}}</dd></dl>
                                        <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd>{{me.showname}}</dd></dl>
                                        <dl><dt>{{$common.dicword('birth',true)}}</dt><dd>{{$common.basic.dateformat( me.birth)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('gender',true)}}</dt><dd>{{$common.chgender(me.sex)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{me.addr}}</dd></dl>
                                    </div>
                                </div>
                            </div>


                            <Cschedule v-if="curnav==1" :options="c_myoption" :stuid="stuid"></Cschedule>
                            <Clecture v-if="curnav==3" :options="c_myoption" :stuid="stuid"></Clecture>
                            <Cactivity v-if="curnav==2" :options="c_myoption" :stuid="stuid"></Cactivity>
                            <Cprogress v-if="curnav==4" :options="c_myoption" :stuid="stuid"></Cprogress>
                            <Clearning v-if="curnav==5" :options="c_myoption" :stuid="stuid"></Clearning>
                            <Ctest v-if="curnav==6" :options="c_myoption" :stuid="stuid"></Ctest>
                            <Cquiz v-if="curnav==7" :options="c_myoption" :stuid="stuid"></Cquiz>
                        </myScroll>
                    </div>
                </div>
            </div>
        </el-dialog>
    </span>

</template>


<script>
    export default {
        name: 'ffmember',
        data() {
            return {
                memnav: [],
                curnav: 0,
                me: {},
                infoschool: {},
                infogroup: {},
                isload: false,
                isshowme: false,
                myoption: {
                    levelid: -1,
                    courseid: -1,
                    topicid: -1,
                    lessonid: -1,
                    realid: 0
                },
                caslevelvalue: '',
                shownavmain: false,
                optionlist: {
                    levellist: [],
                    courselist: [],
                    topiclist: [],
                    lessonlist: [],
                }
            };
        },
        components: {
            Cactivity: () => import('@/components/Cactivity'),
            Cschedule: () => import('@/components/Cschedule'),
            Clecture: () => import('@/components/Clecture'),
            Cprogress: () => import('@/components/Cprogress'),
            Clearning: () => import('@/components/Clearning'),
            Ctest: () => import('@/components/Ctest'),
            Cquiz: () => import('@/components/Cquiz')
        },
        props: {
            username: {
                type: String,
                default: ''
            },
            stuid: {
                type: Number,
                default: 0
            }
        },
        computed: {
            c_navmain: function () {
                return this.$common.basic.fffind(this.memnav, 'kv', this.curnav);
            },
            c_levellist: function () {
                let _levellist = this.$common.basic.jsonclone(this.optionlist.levellist);
                let _courselist = this.$common.basic.jsonclone(this.optionlist.courselist);
                let _topiclist = this.$common.basic.jsonclone(this.optionlist.topiclist);
                let _lessonlist = this.$common.basic.jsonclone(this.optionlist.lessonlist);

                if (this.c_options.showcourse > 3) {
                    this.$common.each(_topiclist, item => {
                        item.x_children = this.$common.basic.fffilter(_lessonlist, "pid", item.id);
                    });
                }
                if (this.c_options.showcourse > 2) {
                    this.$common.each(_courselist, item => {
                        item.x_children = this.$common.basic.fffilter(_topiclist, "pid", item.id);
                    });
                }
                if (this.c_options.showcourse > 1) {
                    this.$common.each(_levellist, item => {
                        item.x_schstat = 0;

                        if (this.c_options.schstat == 1) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 1);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 1;
                            }
                        }
                        else if (this.c_options.schstat == 2) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 2);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 2;
                            }
                        }
                        else if (this.c_options.schstat == 3) {
                            item.x_children = this.$common.basic.fffilter2(_courselist, "levelid", item.id, 'x_schstat', 0);
                            if (this.$common.basic.isarrayexist(item.x_children)) {
                                item.x_schstat = 0;
                            }
                        }
                        else {
                            item.x_children = this.$common.basic.fffilter(_courselist, "levelid", item.id);
                        }

                    });
                }

                if (this.c_options.schstat == 1) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 1);
                }
                else if (this.c_options.schstat == 2) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 2);
                }
                else if (this.c_options.schstat == 3) {
                    _levellist = this.$common.basic.fffilter(_levellist, 'x_schstat', 0);
                }

                return _levellist;
            },
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 4, 'showcourse': 2, 'noteng': 0, 'anycourse': true
                };
                switch (this.curnav) {
                    case 1:
                        _options.showcourse = 2;
                        break;
                    case 2:
                        _options.showcourse = 2;
                        _options.anycourse = false;
                        break;
                    case 3:
                        _options.showcourse = 2;
                        break;
                    case 4:
                        _options.showcourse = 2;
                        break;
                    case 5:
                        _options.showcourse = 4;
                        break;
                    case 6:
                        _options.showcourse = 2;
                        break;
                }

                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            },
            casoption: function () {
                return this.c_options.anycourse ? { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            }
        },
        methods: {
            showme: function () {
                let jsondata = { 'postdata': { 'act': 'tc_mem_navsub', "id": this.stuid } };
                this.$common.post(jsondata, res => {
                    if (res.infodata) {
                        this.memnav = res.infodata;
                        this.me = res.infodatame;
                        this.infoschool = res.infodataschool;
                        this.infogroup = res.infodatagroup;

                        this.isshowme = true;
                        if (res.infodata.length > 1) {
                            this.getoptions();
                        }

                    }

                });

            },
            optionchange: function (e) {
                this.$refs.caslevel.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.myoption.levelid = e[0];
                    this.myoption.courseid = e.length > 1 ? e[1] : -1;
                    this.myoption.topicid = e.length > 2 ? e[2] : -1;
                    this.myoption.lessonid = e.length > 3 ? e[3] : -1;
                }
                else {
                    this.myoption.levelid = -1;
                    this.myoption.courseid = -1;
                    this.myoption.topicid = -1;
                    this.myoption.lessonid = -1;
                }

                this.myoption.realid = 0;
                if (this.myoption.courseid > 0) {
                    let course = this.$common.basic.fffind(this.optionlist.courselist, 'id', this.myoption.courseid);
                    if (this.$common.basic.isobjexist(course)) {
                        this.myoption.realid = course.realid;
                    }
                }
                this.getdata();
            },
            getoptions: function () {
                let jsondata = {
                    'postdata': { 'act': 'tc_mem_options', 'data': { 'courselev': this.c_options.courselev, 'noteng': this.c_options.noteng, 'stuid': this.stuid } }, 'msg': ''
                };
                this.$common.post(jsondata, res => {

                    this.optionlist.levellist = res.infodata || [];
                    this.optionlist.courselist = res.infodatacourse || [];
                    this.optionlist.topiclist = res.infodatatopic || [];
                    this.optionlist.lessonlist = res.infodatalesson || [];
                    this.optionlist.schlist = res.infodatasch || [];

                    this.optionlist.statlist = res.infodatastat;
                });

            },
            showsub: function (v) {
                if (v == 2) {
                    if (this.myoption.courseid <= 0) {
                        let firstlevelid = this.$common.basic.isarrayexist(this.c_levellist) ? this.c_levellist[0].id || 0 : 0;
                        let firstcourse = firstlevelid ? this.$common.basic.isarrayexist(this.c_levellist[0].x_children) ? this.c_levellist[0].x_children[0] || {} : {} : {};
                        this.caslevelvalue = [firstlevelid, firstcourse.id || 0];
                        this.myoption.levelid = firstlevelid;
                        this.myoption.courseid = firstcourse.id || 0;
                        this.myoption.realid = firstcourse.realid || 0;
                    }

                }
                this.curnav = v;
            },
            getdata: function () {
                let cnav = this.curnav;
                this.curnav = -1;
                this.$nextTick(() => {
                    this.curnav = cnav;
                });
            }
        }
    }
</script>
